import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {
  GuidIdAndLabel,
  BrandAndMarketListItem
} from '../../../integrated-client/models/';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  pageNumber: number
  pageSize: number
  offset: number
  limit: number
  brandAndMarket: BrandAndMarketListItem | null
  provider: GuidIdAndLabel | null
  showNonEffective: boolean
  total: number
  currentPage: number
}

export class FormData implements IFormData {

  pageNumber: number
  pageSize: number
  offset: number
  limit: number
  brandAndMarket: BrandAndMarketListItem | null
  provider: GuidIdAndLabel | null
  showNonEffective: boolean
  total: number
  currentPage: number

  constructor() {
    this.pageNumber = 1;
    this.pageSize = DEFAULT_LIMIT;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.brandAndMarket = null;
    this.provider = null;
    this.showNonEffective = false;
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage = 1
  }

}
